/**
 * Lowercase hex SHA-256 of the UTF-8 bytes of `text`: the server's
 * `content_sha256` contract for posters (an HTML frame's `content.html`, a
 * file frame's `content.url`).
 */
export async function sha256Hex(text: string): Promise<string> {
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(text),
  );
  return Array.from(new Uint8Array(digest), (byte) =>
    byte.toString(16).padStart(2, "0"),
  ).join("");
}
